module.exports = __webpack_public_path__ + "img/calendar-8_fill.83b00c79.svg";